/**
 * Fachliche Abweisung eines Befehls (befehle.md §4.2, §7). Der Grund ist ein Wert aus TESTSPRACHE §4 bzw. aus den
 * Feature Files des Bereichs, nie Freitext. Die Plattform übersetzt eine Abweisung in HTTP 422 mit `grund`.
 */
export class Abweisung extends Error {
  constructor(readonly grund: string) {
    super(grund);
    this.name = "Abweisung";
  }
}

export function abweisen(grund: string): never {
  throw new Abweisung(grund);
}

/** Bricht mit `grund` ab, wenn `bedingung` nicht gilt. */
export function verlangen(bedingung: unknown, grund: string): asserts bedingung {
  if (!bedingung) throw new Abweisung(grund);
}
